import { Component, ElementRef, OnInit, ViewChild } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { AuthenticationService } from "../../_services/authentication.service";
import { ActivatedRoute, NavigationExtras, Router } from "@angular/router";
import { AppComponent } from "../../app.component";
import { CurrencyPipe, DatePipe } from "@angular/common";

@Component({
  selector: "app-quotation",
  templateUrl: "./quotation.component.html",
  styleUrls: ["./quotation.component.scss"],
})
export class QuotationComponent implements OnInit {
  quotationForm: FormGroup;
  msg: any;
  role: any;
  filterPlazos: any;
  allPlazos: any;
  editData: any;
  prontoAlert: boolean = false;

  @ViewChild("quote") invoiceElement!: ElementRef;
  aprs: any[];
  values: {
    id: number;
    apr: number;
    contract_type: string;
    factor: number;
    months: number;
    minimum_down_payment: number;
  }[];

  minPronto = 0;
  downPaymentMsg = "";
  wrongPronto = false;

  constructor(
    private datePipe: DatePipe,
    private appCpmp: AppComponent,
    private route: ActivatedRoute,
    private formBuilder: FormBuilder,
    private authenticationService: AuthenticationService,
    private router: Router
  ) {
    this.route.queryParams.subscribe((params) => {
      if (this.router.getCurrentNavigation()!.extras.state) {
        let data: any = this.router.getCurrentNavigation()!.extras.state;
      }
    });
  }

  async ngOnInit() {
    this.getParameters();

    this.role = this.authenticationService.getUserRole();

    this.quotationForm = this.formBuilder.group({
      name: [""],
      premium: ["", [Validators.required]],
      minimalAmmount: ["", [Validators.required]],
      financingAmmount: ["", [Validators.required]],
      months: ["", [Validators.required]],
      apr: ["", [Validators.required]],
      aprSelection: ["", [Validators.required]],
      downPayment: ["", [Validators.required]],
      interestPay: ["", [Validators.required]],
      totalPayment: ["", [Validators.required]],
      splitPayments: ["", [Validators.required]],
      annualPercent: ["", [Validators.required]],
      quarterlyPayments: [""],
      multiplePolicies: [""],
      companyId: [""],
    });
    this.quotationForm.controls["financingAmmount"].disable();
    this.quotationForm.controls["aprSelection"].disable();
    this.quotationForm.controls["interestPay"].disable();
    this.quotationForm.controls["totalPayment"].disable();
    this.quotationForm.controls["splitPayments"].disable();
    this.quotationForm.controls["annualPercent"].disable();
  }

  getParameters() {
    this.authenticationService.getParameters().then((res: any) => {
      this.allPlazos = res[0];
      //remove repeared months and apr
      //  this.allPlazos = res[0].filter((item: any, index: number, self: any) =>
      //     index === self.findIndex((t: any) => (
      //       t.months === item.months && t.apr === item.apr
      //     ))
      //   );
      console.log(this.allPlazos);
      const uniqueAprs = Array.from(
        new Set(res[0].map((item: any) => item.apr))
      );

      let filteredAprs = uniqueAprs;


      const sucAgency = this.authenticationService.getSucAgency();
      const isVirginIsland = sucAgency == "76";
      if (isVirginIsland) {
        const aceptedAprs = [11.0];
        filteredAprs = filteredAprs.filter((a:any) => aceptedAprs.includes(a))
      } else {
        const aceptedAprs = [24.5, 18.5];
        filteredAprs = filteredAprs.filter((a:any) => aceptedAprs.includes(a))
      }
      
      this.aprs = filteredAprs;
      console.log(uniqueAprs);
    });
  }

  updateData(prontoUpdate = false) {
    if (this.quotationForm.value.downPayment > this.quotationForm.value.premium) {
      this.wrongPronto = true;
      this.filterPlazos = [];
      alert("El pronto no debería ser mayor que la prima total.");
      return;
    } else this.wrongPronto = false
    let pronto = this.quotationForm.value.premium * 0.25;
    this.minPronto = pronto < 20 ? 20 : pronto;

    // if (!prontoUpdate)
    this.quotationForm.patchValue({
      //downPayment: pronto, // If you enable it will override pronto input.
      aprSelection: this.quotationForm.value.apr,
    });
    // else
    //   this.quotationForm.patchValue({
    //     aprSelection: this.quotationForm.value.apr,
    //   });
    let financingAmmount = Number(
      (this.quotationForm.value.premium - this.quotationForm.value.downPayment).toFixed(2)
    );
    console.log('👉 this.allPlazos', this.allPlazos, '👈');
    let filterPlazos = this.allPlazos.filter(
      (x: any) => {
        return x.apr == this.quotationForm.value.apr && ([3,6,9].includes(x.months))
      }
    );
    // filter repeated
    filterPlazos = filterPlazos.filter(
      (item: any, index: number, self: any) =>
        index === self.findIndex((t: any) => t.months === item.months)
    );
    // add to array of objects Total a pagar, Pago mensual, % interes anual
    filterPlazos = filterPlazos.map((x: any) => {
      const pagoMensual = Number((financingAmmount * x.factor).toFixed(2));
      x.totalPayment = (pagoMensual * x.months).toFixed(2);
      x.monthlyPay = pagoMensual;
      x.interestPay =
        pagoMensual * x.months - Number(financingAmmount.toFixed(2));
      return x;
    });
    this.filterPlazos = filterPlazos;
    console.log(this.filterPlazos);

    let apr = this.quotationForm.value.apr;

    // if(prodPercent){
    //   let data:any = this.data[0].filter((x:any) => x.apr == prodPercent);
    //   data = data.map((x:any) => {
    //     x.monthlyPay = financingAmmount * x.factor;
    //     x.totalPayment = (financingAmmount * x.factor) * x.months;
    //     x.interestPay = (financingAmmount * x.factor) * x.months - financingAmmount;
    //     return x;
    //   })
    //   console.log(data);
    //   // filter where data where months dont repeat no 3 3
    //   let uniqueMonths = Array.from(new Set(data.map((item: any) => item.months)));
    //   this.allPlazos = uniqueMonths.map((month: any) => {
    //     return data.find((item: any) => item.months === month);
    //   }
    //   );
    //   console.log(this.allPlazos);
    // }

    console.log(this.quotationForm.value.primaTotal);

    if (this.quotationForm.value.months) {
      let data2: any = this.filterPlazos.filter((x: any) => x.apr == apr);

      data2 = data2.filter(
        (x: any) => x.months == this.quotationForm.value.months
      );
      data2 = data2[0];
      this.quotationForm.patchValue({
        interestPay: data2.interestPay.toFixed(2),
        totalPayment: (
          Number(data2.monthlyPay.toFixed(2)) *
          Number(this.quotationForm.value.months)
        ).toFixed(2),
        splitPayments: data2.monthlyPay.toFixed(2),
        annualPercent: data2.apr.toFixed(2),
      });
    }

    this.quotationForm.patchValue({
      minimalAmmount: pronto,
      percentInterest: this.quotationForm.value.prodPercent,
      financingAmmount: financingAmmount,
      // interestPay: financingAmmount * (this.quotationForm.value.prodPercent / 100),
    });
  }

  async createContract() {
    let data = this.quotationForm.getRawValue();
    const interestPay = Number(data.interestPay);
    if (interestPay < 20 && (data.months === "3" || data.months === "6")) {
      try {
        const response = await this.authenticationService.getaprlessthan20({
          finance_amount: data.financingAmmount,
        });
        data.aprLessThan20 = response[0][0].apr.toFixed(2);
        data.lessThan20 = true;
        data.interesLessThan20 = 20;
        alert("Este préstamo tiene un interés menor de $20.00")
      } catch (error) {
        console.log("🚨 ERROR", error, "🚨");
      }
    }
    this.router.navigate(["create-contract"], { state: { data: data } });
  }

  checkProntoMin() {
    const formRawValue = this.quotationForm.getRawValue();
    const pronto = formRawValue && formRawValue.downPayment;
    if (pronto && pronto < this.minPronto) {
      // this.quotationForm.patchValue({ downPayment: this.minPronto });
      const currencyPipe = new CurrencyPipe("en-US");
      this.wrongPronto = true;
      this.downPaymentMsg =
        "El pronto no puede ser menor que el 25% de la Prima Total. " +
        `(${currencyPipe.transform(this.minPronto)})`;
    } else if (this.quotationForm.value.downPayment > this.quotationForm.value.premium){
      this.downPaymentMsg = "El pronto no debe ser mayor que la prima total ";
      this.wrongPronto = true;
      this.updateData();
    } else {
      this.downPaymentMsg = "";
      this.updateData();
      this.wrongPronto = false;
    }
  }
}
